/**
 * SI unit.
 */
export type Unit =
  | 'MILLILITERS'
  | 'CENTILITERS'
  | 'DECILITERS'
  | 'LITERS'
  | 'GRAMS'
  | 'DECAGRAMS'
  | 'KILOGRAMS'
  | 'PIECES';

export const Unit = {
  Milliliters: 'MILLILITERS' as Unit,
  Centiliters: 'CENTILITERS' as Unit,
  Deciliters: 'DECILITERS' as Unit,
  Liters: 'LITERS' as Unit,
  Grams: 'GRAMS' as Unit,
  Decagrams: 'DECAGRAMS' as Unit,
  Kilograms: 'KILOGRAMS' as Unit,
  Pieces: 'PIECES' as Unit,
};
